export function optionsControl(
  showOptions: boolean,
  setShowOptions: React.Dispatch<React.SetStateAction<boolean>>,
  activeOption: number,
  setActiveOption: React.Dispatch<React.SetStateAction<number>>,
  options: { label: string; value: string | boolean | number }[] | undefined,
  optionFilter: string | undefined,
  onOptionChange?: (value?: {
    label: string;
    value: string | boolean | number;
  }) => void
) {
  if (!options) return {};
  options = options.filter((option) =>
    optionFilter
      ? option.label.toLowerCase().includes(optionFilter.toLowerCase())
      : true
  );
  return {
    onInput: () => {
      if (options && !showOptions) {
        setShowOptions(true);
        setActiveOption(-1);
      }
    },
    onKeyDown: (e: React.KeyboardEvent<HTMLInputElement>) => {
      if (!options || !showOptions) return;
      const active =
        activeOption >= options.length ? options.length : activeOption;
      if (e.key === 'ArrowDown' && active < options.length - 1)
        setActiveOption(active + 1);
      else if (e.key === 'ArrowUp' && active > 0) setActiveOption(active - 1);
      else if (e.key === 'Enter') {
        onOptionChange?.(options[active]);
        setShowOptions(false);
      } else return;
      e.preventDefault();
    },
    onFocus: () => {
      if (options) {
        setShowOptions(true);
        setActiveOption(-1);
      }
    },
    onBlur: (e: React.FocusEvent<HTMLInputElement>) => {
      const focused = e.nativeEvent?.relatedTarget as HTMLElement | null;
      if (focused?.classList?.contains('form-input__option')) return;
      if (!options?.find((option) => option.label.includes(e.target.value)))
        onOptionChange?.();
      if (!e.relatedTarget?.classList.contains('form-input__option'))
        setShowOptions(false);
    },
  };
}

export default function InputOption(props: {
  inputId: string;
  options?: { label: string; value: string | boolean | number }[];
  activeOption: number;
  optionFilter?: string;
  setActiveOption: React.Dispatch<React.SetStateAction<number>>;
  showOptions: boolean;
  setShowOptions: React.Dispatch<React.SetStateAction<boolean>>;
  onOptionChange?: (value?: {
    label: string;
    value: string | boolean | number;
  }) => void;
}) {
  const options =
    props.options?.filter((option) =>
      props.optionFilter
        ? option.label.toLowerCase().includes(props.optionFilter.toLowerCase())
        : true
    ) || [];
  if (!options.length) return <></>;
  return (
    <div className="form-input__options">
      <hr className="form-input__separator" />
      {options.map((option, index) => {
        const btnClasses = ['btn', 'form-input__option'];
        if (props.activeOption === index)
          btnClasses.push('form-input__option--active');

        return (
          <button
            type="button"
            key={`option-${props.inputId}-${option.value}`}
            className={btnClasses.join(' ')}
            onClick={() => {
              props.onOptionChange?.(option);
              props.setShowOptions(false);
            }}
          >
            <span className="form-input__option__label">{option.label}</span>
          </button>
        );
      })}
    </div>
  );
}
